import { createAction, props, createReducer, on } from '@ngrx/store';
import { FlightReducerInitState } from '../models/flight-reducer.interface';

// Action definitions using createAction
export const updateFlightRequest = createAction(
  '[Flight] Update Flight Request',
  props<{ payload: any }>()
);

export const updateFlightResponse = createAction(
  '[Flight] Update Flight Response',
  props<{ payload: any }>()
);

export const updateFinalDestination = createAction(
  '[Flight] Update Final Destination',
  props<{ payload: any }>()
);

export const updateManualDestination = createAction(
  '[Flight] Update Manual Destination',
  props<{ payload: any }>()
);

export const updateFlightProducts = createAction(
  '[Flight] Update Flight Products',
  props<{ payload: any }>()
);

export const updateFlightLanded = createAction(
  '[Flight] Update Flight Landed',
  props<{ payload: boolean }>()
);

export const refreshFlightState = createAction(
  '[Flight] Refresh Flight State',
  props<{ payload: any }>()
);

export const resetFlightState = createAction(
  '[Flight] Reset Flight State'
);

// Initial state
const initState: FlightReducerInitState = {
  flightDetails: {
    flightRequest: {},
    flightResponse: {},
    flightFinalDestination: { airportCode: '', airportName: '', airportCityName: '', airportCountryName: '' },
    flightManualDestination: {},
    flightProducts: {
      abc: false,
      ccd: false,
      sds: false,
      isDomesticABC: false
    },
    flightLanded: false
  }
};

// Reducer using createReducer and on
export const flightReducer = createReducer(
  initState,
  on(updateFlightRequest, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightRequest: payload }
  })),
  on(updateFlightResponse, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightResponse: payload }
  })),
  on(updateFinalDestination, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightFinalDestination: payload }
  })),
  on(updateManualDestination, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightManualDestination: payload }
  })),
  on(updateFlightProducts, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightProducts: payload }
  })),
  on(updateFlightLanded, (state, { payload }) => ({
    ...state,
    flightDetails: { ...state.flightDetails, flightLanded: payload }
  })),
  on(refreshFlightState, (state, { payload }) => ({
    ...payload
  })),
  on(resetFlightState, () => ({ ...initState }))
);
